<template>
    <div id="background_menu">
        <section class="menu-ctrl">
            <span class="menu-ctrl__text">{{ $t('__background.top_hint') }}</span>
            <div class="icon-container">
                <QpeTooltip>
                    <template #hovered_item>
                        <v-icon 
                            color="white"
                            @click="close_all"
                        >
                            icon-unfold-less
                        </v-icon>
                    </template>
                    <template #tooltip_content>
                        <span>{{ $t('__map_obs.close_all_tree') }}</span>
                    </template>
                </QpeTooltip>
                <QpeTooltip>
                    <template #hovered_item>
                        <v-icon 
                            color="white"
                            @click="cancel_all"
                        >
                            icon-cancle-select                        
                        </v-icon>
                    </template>
                    <template #tooltip_content>
                        <span>{{ $t('__map_obs.cancel_all') }}</span>
                    </template>
                </QpeTooltip>
            </div>
        </section>
        <div id="background">
            <div v-if="init_items.length > 0">
                <TreeView
                    :name="'background'"
                    ref="child_treeview"
                    :current_tab="'geomap'"
                    :init_items="init_items"
                    :checked_selectors="checked_selectors"
                    :init_opened_layers="init_opened_layers"
                    :opened_with_btn="true"
                    :enable_all_select_in_treeview_children_radios="true"
                    :selected_product_count_callback="selected_product_count_callback"
                    :special_list="special_list"
                    @control_special_list="_control_special_checkboxes"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { get_geomap_ajax } from '@/utils/emap/emap_init.js';
    import { STATIC_SVG_ROOT } from '@/config/config.js'
    import { MENU_ICON } from '@/config/menu_config.js'
    import { mapMutations, mapState } from 'vuex'
    import TreeView from '../../tree_view.vue'

    export default {
        name: 'Background',
        
        components: {
            TreeView,
            QpeTooltip: () => import('@/components/tool/qpe_tooltip.vue'),
        },

        data() {
            return {
                STATIC_SVG_ROOT: STATIC_SVG_ROOT,

                init_opened_layers:[],
                init_items: [],
                checked_selectors: {},
                selected_items: [],
                point_dom_timer: {},
                special_list: ['id_165_2324', 'id_165_18625']
            }
        },

        computed: {
            ...mapState([
                'client_name',
                'language', 
                'i18n_language'
            ]),

            ...mapState('emap', [
                'first_time_render'
            ]),

            geomap_get_api_params() {
                return {
                    params: {
                        lang: this.language
                    }
                }
            }
        },
        
        watch: {
            language: {
                immediate: true,
                handler() {
                    this.initialize();
                }
            }
        },
        
        methods: {
            ...mapMutations('emap', [
                'set_selected_background_products'
            ]),

            async initialize() {
                try {
                    const response = await get_geomap_ajax(this.client_name, this.geomap_get_api_params);
                    const _data = typeof response.data === 'object' ? response.data : JSON.parse(response.data); 
                    this._reconstruct_geomap_data(_data['geomap_data']);
                } catch(err) {
                    console.error(err);
                }
                this.update_background()
            },

            _reconstruct_geomap_data(geomap_data) {
                //value裡面會放所有屬於該第一層的所有data
                this.init_opened_layers = [...new Set(geomap_data.map(geomap_datum => geomap_datum.data_category))]
                const items_groupby_layer1 = this.init_opened_layers.map(name => { 
                    return {
                        'id': name + '_root',
                        'name': name, 
                        'values': []
                    }
                });

                geomap_data.forEach(geomap_datum => {
                    const order = this.init_opened_layers.indexOf(geomap_datum['data_category']);
                    items_groupby_layer1[order]['values'].push(geomap_datum);
                })

                //依序跑不同的第一層把該層的children塞進去
                this.init_items =  this.init_opened_layers.map((layer_name, i) => {  
                    const results_groupby_layer1 = this._generate_geomap_layer2and3(items_groupby_layer1[i]['values']);
                    const main_item = {
                        'id': layer_name + '_root',
                        'name':layer_name, 
                        'node':true, 
                        'layer1':true, 
                        'radio_name': `${layer_name}root`,
                        'children': results_groupby_layer1,
                        'icon': MENU_ICON[layer_name]
                    }

                    return main_item
                })
                this.init_opened_layers = this.init_opened_layers.map(x => x + '_root');
                this.checked_selectors = this._generate_checked_property(geomap_data);
                this.selected_items = this._generate_selected_items();
            },

            _generate_geomap_layer2and3(items) { //同一個category的
                let ary = [];
                let layer2_list = [];
                for(let item of items) {
                    const layer2_name = item['data_source'];
                    const id = item['data_name']
                    const files = item['data_file'];

                    const item_type = item['data_group'] ? 'optional_radio' : 'checkbox';
                    
                    const item_obj = {
                        'node': false, 
                        'layer1': false, 
                        'type': item_type, 
                        'radio_name': item['data_category'], 
                        'index': 0
                    };
                    
                    //有data_source 表示第三層有內容
                    if (layer2_name) {

                        //沒有此layer2 因此要新建 
                        if (!(layer2_list.includes(layer2_name))) {
                            layer2_list.push(layer2_name);
                            ary.push({
                                'id': `${layer2_name}_layer2`,
                                'name':layer2_name, 
                                'node':true, 
                                'layer1':false, 
                                'children':[]
                            });  
                        }
                        let order = layer2_list.indexOf(layer2_name);
                        // 給選項加一個全選/取消全選

                        if(item['checked_all_btn']) {
                            ary[order]['children'].push({
                                'id': `${id}_check_all`, 
                                'id_group': id,
                                'name': '全選/取消全選',
                                'radio_name': layer2_name, 
                                'type': 'check_all', 
                                'index': ary[order]['children'].length,
                                'node': false,
                            })
                        }

                        if(item['show_path_btn']) {
                            ary[order]['children'].push({
                                'id': `${id}_show_path`,
                                'id_group': id,
                                'id_belongs': id,
                                'name': item['show_path_btn'],
                                'radio_name': layer2_name, 
                                'type': 'checkbox', 
                                'index': ary[order]['children'].length,
                                'default_checked': true,
                                'method': 'show_path'
                            });
                        }
                            
                        if(item['show_point_btn']) {
                            ary[order]['children'].push({
                                'id': `${id}_show_point`,
                                'id_group': id,
                                'id_belongs': id,
                                'name': item['show_point_btn'],
                                'radio_name': layer2_name, 
                                'type': 'checkbox', 
                                'index': ary[order]['children'].length,
                                'default_checked': true,
                                'method': 'show_point'
                            });
                        }

                        files.map(file => {   
                            const layer3_name = file['file_descriptiion'];
                            const tmp_obj = Object.assign({}, item_obj, {
                                'id': `${id}_${file['id']}`,
                                'name': layer3_name,
                                'radio_name': `${item['data_category']}/${layer2_name}/${layer3_name}`,
                                'index': ary[order]['children'].length,
                            })
                                                        
                            ary[order]['children'].push(tmp_obj);
                        })
                    } else {
                        files.forEach((file, i) => {
                            const tmp_obj = Object.assign({}, item_obj, {
                                'id': `${id}_${file['id']}`,
                                'name': file['file_descriptiion'],
                                'index': i,
                            })

                            ary.push(tmp_obj);
                        })                  
                    }
                }
                return ary;
            },

            _generate_checked_property(source_items) {
                let return_selectors = {}
                source_items.forEach(item => {
                    const id = item['data_name']
                    if(item['checked_all_btn']) {
                        return_selectors[`${id}_check_all`] = {
                            'id': `${id}_check_all`, 
                            'checked': false,
                        }
                    }

                    if(item['show_path_btn']) {
                        return_selectors[`${id}_show_path`] = {
                            'id': `${id}_show_path`,
                            'id_group' : `${id}`,
                            'id_belongs': id,
                            'checked': true,
                            'method': 'show_path'
                        }
                    }
                        
                    if(item['show_point_btn']) {
                        return_selectors[`${id}_show_point`] = {
                            'id': `${id}_show_point`,
                            'id_group' : `${id}`,
                            'id_belongs': id,
                            'checked': true,
                            'method': 'show_point'
                        }
                    }

                    let external_config = {}
                    if(item['data_type'] === 'external') {
                        external_config = {
                            'product_type': item['data_type'],
                            'product_sub_type': item['data_sub_type'],
                            'api_path': item['external'],
                        }
                    }

                    item.data_file.forEach(file => {
                        const selector_id = `${item['data_name']}_${file['id']}`
                        const is_data_file_exist = this.checked_selectors[selector_id] !== undefined
                        const checked_property = {
                            'id': selector_id,
                            'id_belongs': id,
                            'checked': is_data_file_exist ? this.checked_selectors[selector_id].checked  : item['default_checked'],
                            'data_category': item['data_category'],
                            'file_path': file['file_path'],
                            'config': file['config'],
                            'pane_order': item['data_order'],
                            'color_line': item['color_line'],
                        }
                        return_selectors[selector_id] = { ...checked_property, ...external_config }
                    })
                })
                return return_selectors
            },

            async update_background() {
                this.selected_items = this._generate_selected_items(); 
                this.set_selected_background_products(this.selected_items)
                this.control_background_display()
            },

            check_related_id_from_emap_menu (background_menu_related_ids) {
                const NO_AUTO_CHECK_FEATURE = ['show_path', 'show_point']
                const background_menu_ids = Object.keys(this.checked_selectors)

                background_menu_related_ids.forEach(related_id => {
                    background_menu_ids
                        .filter(background_menu_id => {
                            const geomap_id = background_menu_id.split('_').slice(0, 2).join('_')
                            const is_feature_toggle_btn = NO_AUTO_CHECK_FEATURE.find(text => background_menu_id.includes(text)) 
                            return geomap_id === related_id && !is_feature_toggle_btn
                        })
                        .forEach(id => this.$set(this.checked_selectors[id], 'checked', true))
                })

                this.update_background()
            },
          
            _control_special_checkboxes(idx, node_name, name, id) {
                const status = this.checked_selectors[id]['checked']
                this.$set(this.checked_selectors[id], 'checked', status);

                // CAA 特別需求，目前底圖 同時打開其他產品 功能寫死
                if(status && this.special_list.includes(id)) {
                    this.special_list.forEach(id => this.$set(this.checked_selectors[id], 'checked', true))
                    this.$forceUpdate();
                }
            },

            cancel_all() {
                Object.keys(this.checked_selectors).forEach(id => {
                    this.$set(this.checked_selectors[id], 'checked', false);
                });

                this.update_background()
            },

            close_all() {
                this.$refs.child_treeview.close_all_trees();
            },

            _generate_selected_items() {
                return Object.values(this.checked_selectors)
                    .filter(item => item['file_path'] && item['checked'])
            },

            control_background_display() {
                Object.values(this.checked_selectors)
                    .filter(({ method }) => method)
                    .forEach(item => this._assign_background_display_method(item))
            },

            _assign_background_display_method({ id_group, checked, method }) {
                const be_controlled_background_id_set = this.selected_items
                    .filter(({ id_belongs }) => id_belongs === id_group)
                    .map(({ id }) => id);

                if(method === 'show_path') {
                    return setTimeout(() => this._show_background_path(checked, be_controlled_background_id_set), 100);
                }
                if(method === 'show_point') {
                    // 點要等圖畫完才能隱藏
                    return setTimeout(() => this._show_background_point(checked, be_controlled_background_id_set), 0);
                }
            },
            
            _show_background_path(is_show, background_id_set) {
                background_id_set.forEach(background_id => {
                    const background_dom = document.querySelectorAll(`.leaflet-${background_id}-pane > svg .alert_line`)
                    if(background_dom) {
                        this._set_visibility_timer(background_id, is_show, 'svg')
                    }
                })
            },

            _show_background_point(is_show, background_id_set) {
                background_id_set.forEach(background_id => {
                    const background_dom = document.querySelectorAll(`.leaflet-${background_id}-pane > .leaflet-marker-icon`)
                    if(background_dom) {
                        this._set_visibility_timer(background_id, is_show, 'icon')
                    }
                })
            },

            _set_visibility_timer(background_id, is_show, type) {
                const dom_name = type === 'svg' ? `.leaflet-${background_id}-pane > svg .alert_line` : `.leaflet-${background_id}-pane > .leaflet-marker-icon`
                const background_dom = document.querySelectorAll(dom_name)
                if (this.point_dom_timer[background_id]) clearTimeout(this.point_dom_timer[background_id])
                if (background_dom.length > 0) return this._set_visibility(background_dom, is_show, type)
                this.point_dom_timer[background_id] = setTimeout(() => this._set_visibility_timer(background_id, is_show, type), 10)
            },

            _set_visibility(background_dom, is_show) {
                background_dom.forEach(background_dom_children => {
                    background_dom_children.style.visibility = is_show ? 'visible' : 'hidden'
                })
            },
            
            selected_product_count_callback() {
                return ((accumulator, selector) => {
                    const { data_category, checked } = selector
                    // 沒有 data_category 表示不是產品，是功能選項
                    if (!data_category) {
                        return accumulator
                    }

                    let current_checked_count = accumulator[data_category] ?? 0
                    if (checked) current_checked_count += 1
                    return {
                        ...accumulator, 
                        ...{
                            [data_category]: current_checked_count
                        }
                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin.scss';

    #background {
        height: calc(100vh - 128px);
        background: #454d66;
        overflow: auto;

        @include laptop {
			height: calc(var(--app-height) - 128px );
		}
    }
    
    #background.eng-height {
        height: calc(100vh - 345px);
    }

    .menu-ctrl {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--base-gray-darken);
        padding: 3px;

        .icon {
            width: 24px;
            height: 24px;
            object-fit: contain;
            cursor: pointer;
        }

        &__text {
            margin-left: 1em;
            color: var(--grey-pipe);
        }
    }
</style>